import { ReplaceWhitelistBody, WhitelistItem } from 'multirpc-sdk';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';

import { RootState } from 'store';

import { replaceWhitelist } from '../replaceWhitelist';
import { createFilteredWhitelistBody } from './createFilteredWhitelistBody';

export interface UpdateWhitelistParams {
  userEndpointToken: string;
  group?: string;
  removedChains: string[];
  originalWhitelist: WhitelistItem[];
  isAllChainsRemoved: boolean;
  dispatch: ThunkDispatch<RootState, unknown, AnyAction>;
}

export async function updateWhitelistWithRemovedChains(
  params: UpdateWhitelistParams,
): Promise<void> {
  const {
    dispatch,
    group,
    isAllChainsRemoved,
    originalWhitelist,
    removedChains,
    userEndpointToken,
  } = params;

  let filteredWhitelistBody: ReplaceWhitelistBody;

  if (isAllChainsRemoved) {
    filteredWhitelistBody = {
      address: {},
      ip: {},
      referer: {},
    };
  } else {
    // Otherwise, filter out only the removed chains
    filteredWhitelistBody = createFilteredWhitelistBody({
      originalWhitelist,
      removedChains,
    });
  }

  await dispatch(
    replaceWhitelist.initiate({
      params: {
        token: userEndpointToken,
        group,
        whitelist: filteredWhitelistBody,
      },
    }),
  );
}
